var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
var AUTO_DISMISS_MS = 8000;
var MAX_VISIBLE = 4;
var nextEntryId = 1;
var entries = [];
var listeners = new Set();
var emit = function () { return listeners.forEach(function (listener) { return listener(); }); };
export var pushScanError = function (text) {
    entries = __spreadArray(__spreadArray([], entries, true), [{ id: nextEntryId++, text: text }], false);
    emit();
};
export var dismissScanError = function (id) {
    if (!entries.some(function (entry) { return entry.id === id; }))
        return;
    entries = entries.filter(function (entry) { return entry.id !== id; });
    emit();
};
export var clearScanErrors = function () {
    if (entries.length === 0)
        return;
    entries = [];
    emit();
};
var ScanErrorCard = function (_a) {
    var entry = _a.entry;
    useEffect(function () {
        var timerId = window.setTimeout(function () { return dismissScanError(entry.id); }, AUTO_DISMISS_MS);
        return function () { return window.clearTimeout(timerId); };
    }, [entry.id]);
    return (_jsxs("div", __assign({ role: 'alert', onClick: function () { return dismissScanError(entry.id); }, className: 'pointer-events-auto flex w-full max-w-md cursor-pointer items-start gap-2 rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white shadow-lg' }, { children: [_jsx("span", __assign({ className: 'min-w-0 flex-1 break-words' }, { children: entry.text }), void 0), _jsx(CloseOutlined, { style: { fontSize: 11, marginTop: 4, opacity: 0.85 } }, void 0)] }), void 0));
};
export var ScanErrorStack = function () {
    var _a = useState(entries), current = _a[0], setCurrent = _a[1];
    useEffect(function () {
        var listener = function () { return setCurrent(entries); };
        listeners.add(listener);
        listener(); // catch errors pushed between first render and subscription
        return function () {
            listeners.delete(listener);
        };
    }, []);
    if (current.length === 0)
        return null;
    var visible = current.slice(-MAX_VISIBLE);
    var hiddenCount = current.length - visible.length;
    return (_jsxs("div", __assign({ className: 'pointer-events-none fixed inset-x-0 bottom-20 flex flex-col items-center gap-2 px-4', style: { zIndex: 1100 } }, { children: [hiddenCount > 0 && (_jsx("button", __assign({ type: 'button', onClick: clearScanErrors, className: 'pointer-events-auto rounded-full bg-red-700 px-3 py-1 text-xs font-semibold text-white shadow' }, { children: "+" + hiddenCount + " \u2715" }), void 0)), visible.map(function (entry) { return (_jsx(ScanErrorCard, { entry: entry }, entry.id)); })] }), void 0));
};
export default ScanErrorStack;
